import { PATH_DASHBOARD } from 'src/Router/paths';
import { NavItem } from 'src/features/Navbar/NavItem';
import { TodoListAvatar } from 'src/features/todo/TodoListAvatar';
import useActiveLink from 'src/hooks/useActiveLink';
import { TodoList } from 'src/requests/todos';

type Props = {
  todo: TodoList;
};
export const TodoNavItem = ({ todo }: Props) => {
  const path = PATH_DASHBOARD.todo.view(todo._id);
  const { active } = useActiveLink(path, false);

  return (
    <NavItem
      path={path}
      depth={1}
      icon={<TodoListAvatar key={todo._id} todo={todo} />}
    >
      {todo.name}
    </NavItem>
  );
};
